import { isServerside } from '../core/utils/isServerside';

/**
 * Returns 'mobile' or 'desktop' based on the same logic as FeatureId.DEVICE
 * (used for custom tracking ID hashing and API offers).
 * On server, returns 'mobile'.
 */
export const getDeviceCategory = (): 'mobile' | 'desktop' => {
  if (isServerside()) {
    return 'mobile';
  }
  let hasTouchScreen: boolean;
  if (window.navigator.maxTouchPoints > 0) {
    hasTouchScreen = true;
  } else {
    const mQ = matchMedia('(pointer:coarse)');
    if (mQ.media === '(pointer:coarse)') {
      hasTouchScreen = mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      const UA = navigator.userAgent;
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }
  return hasTouchScreen ? 'mobile' : 'desktop';
};
